// @flow

const multiSelectStrategy = ({options}: FacetWithConfig): boolean => (
    options.length > 0
);

export default multiSelectStrategy;
